"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boxShadow = void 0;
var boxShadow = '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)';
exports.boxShadow = boxShadow;